import { z } from "zod";

export const techniqueProgressionRequestSchema = z
  .object({
    expectedLevel: z.number().int().min(0).max(10),
  })
  .strict();

export type TechniqueProgressionRequest = z.infer<
  typeof techniqueProgressionRequestSchema
>;

export interface TechniqueArchiveProgressionOption {
  targetLevel: number;
  scroll: {
    itemId: string;
    name: string;
    iconKey: string;
    rarity: "uncommon" | "rare" | "epic" | "legendary";
    requiredQuantity: number;
    ownedQuantity: number;
  };
  resources: { ryo: number; energy: number };
  canonicalResources: { ryo: number; energy: number };
  nextMechanics: {
    chakraCost: number;
    cooldownMs: number;
    range: number;
    maxTargets: number;
    power: number;
    healBase?: number;
    healCoefficient?: number;
    shieldBase?: number;
    shieldCoefficient?: number;
    shieldDurationMs?: number;
  };
}

export interface TechniqueArchiveCatalogEntry {
  techniqueId: string;
  name: string;
  family: string;
  proficiency: string;
  targeting: string;
  currentLevel: number | null;
  scrolls: Array<{
    rarity: "uncommon" | "rare" | "epic" | "legendary";
    ownedQuantity: number;
  }>;
  next: TechniqueArchiveProgressionOption | null;
  canAdvance: boolean;
  unavailableReason: string | null;
}

export interface TechniqueArchiveView {
  archive: {
    level: number;
    maxLevel: number;
    feature: string;
    futureLevelsEnabled: false;
  };
  ninja: {
    id: string;
    name: string;
    rarity: string;
    lifeStatus: string;
    activityLock: string | null;
    canProgress: boolean;
    unavailableReason: string | null;
  };
  techniques: TechniqueArchiveCatalogEntry[];
}

export interface TechniqueProgressionResult {
  ninjaId: string;
  techniqueId: string;
  previousLevel: number | null;
  techniqueLevel: number;
  consumedScroll: {
    itemId: string;
    rarity: "uncommon" | "rare" | "epic" | "legendary";
    quantity: number;
  };
  chargedResources: { ryo: number; energy: number };
  replayed: boolean;
}
